module.exports = __webpack_public_path__ + "img/63.9.pH.f8bea185.png";